import { render } from "./AITranscriptionEdit.vue?vue&type=template&id=5219f4ef&scoped=true"
import script from "./AITranscriptionEdit.vue?vue&type=script&lang=js"
export * from "./AITranscriptionEdit.vue?vue&type=script&lang=js"

import "./AITranscriptionEdit.vue?vue&type=style&index=0&id=5219f4ef&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5219f4ef"],['__file',"src/components/aitranscription/AITranscriptionEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5219f4ef"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5219f4ef', __exports__)) {
    api.reload('5219f4ef', __exports__)
  }
  
  module.hot.accept("./AITranscriptionEdit.vue?vue&type=template&id=5219f4ef&scoped=true", () => {
    api.rerender('5219f4ef', render)
  })

}


export default __exports__